import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AccountRegistrationResponse, MinorAccountRegistrationResponse } from '@interfaces';
import { environment } from '@src/environments';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AccountRegistrationService {
  constructor(private http: HttpClient) {}

  callAccountRegistration(): Observable<AccountRegistrationResponse> {
    return this.http.get<AccountRegistrationResponse>(`secure/account-registration`);
  }

  callMinorAccountRegistration(): Observable<MinorAccountRegistrationResponse> {
    return this.http.get<MinorAccountRegistrationResponse>(`secure/minor-account-registration`);
  }
}
